import { Injectable } from '@angular/core';
import { HttpService } from '@etop/common';
import { AuthenticateStore } from '@etop/core';
import { Webhook } from '@etop/models';


@Injectable({
  providedIn: 'root'
})
export class WebhookApi {
  constructor(
    private http: HttpService,
    private auth: AuthenticateStore
  ) {}


  async createWebhook(request: WebhookAPI.CreateWebhookRequest): Promise<Webhook> {
    return await this.http.post('api/shop.Webhook/CreateWebhook', request).toPromise().then(res => res?.webhooks);
  }

  async getWebhooks() {
    return await this.http.post('api/shop.Webhook/GetWebhooks', {}).toPromise().then(res => res?.webhooks);
  }

  async deleteWebhook(id) {
    return await this.http.post('api/shop.Webhook/DeleteWebhook', {id}).toPromise();
  }

}

export namespace WebhookAPI {
  export interface CreateWebhookRequest {
    url: string;
    entities: string[];
    headers?: { header_key: string, header_value: string }[]
  }
}

